export class Utils {
    next(element: Element, clazz: string): Element | undefined {
        let nextElement: Element | null = element;
        if (nextElement) {
            do {
                nextElement = nextElement.nextElementSibling;
            } while (nextElement && !nextElement.classList.contains(clazz));
        }
        return nextElement ? nextElement : undefined;
    }

    parseJsonOrReturn<T>(something: string): T | string {
        try {
            return JSON.parse(something);
        } catch (_e) {
            return something;
        }
    }

    parseJson<T>(something: string): T | Record<string, never> {
        try {
            return JSON.parse(something) || {};
        } catch (_e) {
            return {};
        }
    }

    parseJsonArray<T>(input: string): T[] {
        try {
            return JSON.parse(input);
        } catch (error) {
            console.error(error);
            return [];
        }
    }

    toggle(el: HTMLElement, value: string): void {
        const display = getComputedStyle(el, null).display;
        if (display === 'none') {
            el.style.display = value;
        } else {
            el.style.display = 'none';
        }
    }

    handleAjax<T>(success: (response: Response) => Promise<T>, error: (response: Response) => Promise<T>): (response: Response) => Promise<void> {
        return async (response: Response) => {
            if ((response.status >= 200 && response.status < 300) || response.status === 304) {
                await success(response);
            } else if (response.status === 401) {
                /*                          */
                const redirectTo = this.readResponseRedirectTo(response);
                if (redirectTo) {
                    window.location.href = redirectTo;
                }
            } else {
                if (error && typeof error === 'function') {
                    await error(response);
                }
            }
        };
    }

    handleAjaxSuccessRedirect(response: Response, beforeRedirect: () => unknown = () => {}): boolean {
        const redirectTo = this.readResponseRedirectTo(response);
        if (redirectTo) {
            beforeRedirect();
            this.goto(window, redirectTo);
            return true;
        }
        return false;
    }

    /**
 *
 *
 *
 *
 *
 *
 *
 */
    goto(window: Window, url: string): void {
        function extractUrlWithoutHash(urlWithMaybeHash: string) {
            const hashSignPosition = urlWithMaybeHash.indexOf('#');
            return hashSignPosition > -1 ? urlWithMaybeHash.substring(0, hashSignPosition) : urlWithMaybeHash;
        }

        const newUrlElement = document.createElement('a');

        newUrlElement.href = url;
        const currentUrlWithoutHash = extractUrlWithoutHash(window.location.href);
        const newUrlWithoutHash = extractUrlWithoutHash(newUrlElement.toString());

        if (currentUrlWithoutHash === newUrlWithoutHash) {
            window.location.hash = newUrlElement.hash;
            window.location.reload();
        } else {
            window.location.href = url;
        }
    }

    preload(element: HTMLElement): void {
        window.preload_polyfill_invoke(element);
    }

    readResponseRedirectTo(response: Response): string | null {
        return response.headers.get('X-RedirectTo');
    }

    activateFeatureCompleted(featureName: string): void {
        const jsFeatureTesting = document.getElementsByClassName('order_js_featureComplete')[0];
        if (jsFeatureTesting) {
            jsFeatureTesting.setAttribute('data-' + featureName, 'true');
        }
    }

    static initialize(): void {
        const o_order = window.o_order ?? {};

        o_order.utils = o_order.utils ?? new Utils();
    }
}

declare global {
    interface Window {
        preload_polyfill_invoke: (element: HTMLElement) => void;
    }
}
